import api from 'js/api'

export const signupWithOnboardingService = (
  email: string,
  password: string,
  country: string,
  firstName?: string,
) =>
  api('POST', 'onboarding-service/signup', {
    email,
    password,
    country,
    ...(firstName ? { first_name: firstName } : {}),
  })
